import { render, staticRenderFns } from "./BarcodeField.vue?vue&type=template&id=31be4317&scoped=true&"
import script from "./BarcodeField.vue?vue&type=script&lang=js&"
export * from "./BarcodeField.vue?vue&type=script&lang=js&"
import style0 from "./BarcodeField.vue?vue&type=style&index=0&id=31be4317&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31be4317",
  null
  
)

export default component.exports